
import React from 'react';

interface LogoProps {
  variant?: 'full' | 'horizontal' | 'icon';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Logo = ({ variant = 'full', className = '', size = 'md' }: LogoProps) => {
  const sizeClasses = {
    sm: 'h-24 w-auto',
    md: 'h-32 w-auto',
    lg: 'h-48 w-auto'
  };

  // Updated horizontal logo URL
  const logoUrls = {
    full: 'https://szbvvvxyamindcuymrcr.supabase.co/storage/v1/object/public/brand-assets//logo%20square.PNG',
    horizontal: 'https://szbvvvxyamindcuymrcr.supabase.co/storage/v1/object/public/brand-assets//horiz%20logo.png',
    icon: 'https://szbvvvxyamindcuymrcr.supabase.co/storage/v1/object/public/brand-assets//CampChef%20(2).png'
  };

  return (
    <img 
      src={logoUrls[variant]} 
      alt="CampChef Pro"
      width={size === 'sm' ? '96' : size === 'md' ? '128' : '192'}
      height={size === 'sm' ? '96' : size === 'md' ? '128' : '192'}
      className={`${sizeClasses[size]} ${className}`}
      onError={(e) => {
        // Fallback to text logo if image fails to load
        e.currentTarget.style.display = 'none';
        e.currentTarget.nextElementSibling?.setAttribute('style', 'display: block');
      }}
    />
  );
};

// Fallback text component
export const LogoText = ({ className = '', size = 'md' }: { className?: string; size?: 'sm' | 'md' | 'lg' }) => {
  const textSizeClasses = {
    sm: 'text-lg font-bold',
    md: 'text-xl font-bold',
    lg: 'text-3xl font-bold'
  };

  return (
    <span className={`${textSizeClasses[size]} text-primary ${className}`}>
      CampChef Pro
    </span>
  );
};
